import React from "react";

export default function MSAccess_Min() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Min</h1>
      <p>This is the MSAccess_Min component generated from the SQL JSON.</p>
    </div>
  );
}
